import Container from "../components/core/Container"
import Nav from "../components/Nav"
import Heading from "../components/core/Heading"
import Paragraph from "../components/core/Paragraph"
import SectionTag from "../components/core/SectionTag"
import SEO from "../components/SEO"


export default function ObchodniPodminkyPage() {
    return(
        <>
            <SEO
                title="Obchodní podmínky - digibezstresu"
                description="Obchodní podmínky upravující smluvní vztah mezi poskytovatelem vzdělávacích služeb a účastníky vzdělávacích akcí."
                keywords="obchodní podmínky, smluvní podmínky, storno podmínky, vzdělávací služby"
                url="/obchodni_podminky"
            />
            <Container className="min-h-screen flex flex-col">
                <Nav/>
            <Container className="mt-8 mb-8" bgColor="transparent"/>
            
            <Container className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-16" bgColor="transparent">
                <SectionTag>
                    Obchodní podmínky
                </SectionTag>

                <Container className="pb-6 border-b border-gray-300 mb-6" bgColor="transparent">
                    <Paragraph variant="lead_black">
                        Tyto obchodní podmínky upravují smluvní vztah mezi poskytovatelem vzdělávacích služeb a účastníky vzdělávacích akcí.
                    </Paragraph>
                </Container>

                <Container className="mb-6" bgColor="transparent">
                    <Heading variant="h2">1. Úvodní ustanovení</Heading>
                    <Paragraph>
                        Tyto obchodní podmínky (dále jen „Podmínky") upravují smluvní vztah mezi:
                    </Paragraph>
                    <Container className="bg-gray-50 border border-gray-300 rounded-xl p-4 mt-5" bgColor="gray-50">
                        <Paragraph>
                            <strong>[Mgr. Danuše Kubová]</strong><br />
                            Sídlo / místo podnikání: <strong>[Velichov 163, 363 01 Ostrov]</strong><br />
                            IČO: <strong>[75868822]</strong><br />
                            E-mail: <strong>[kubova@digibezstresu.cz]</strong>
                        </Paragraph>
                    </Container>
                    <Paragraph variant="small" className="mt-2">
                        (dále jen „Poskytovatel")
                    </Paragraph>
                </Container>

                <Container className="mb-6" bgColor="transparent">
                    <Heading variant="h2">2. Předmět plnění</Heading>
                    <Paragraph>
                        Poskytovatel pořádá a zajišťuje vzdělávací akce, kurzy, školení, workshopy nebo semináře (dále jen „Akce").
                    </Paragraph>
                    <Paragraph className="mt-4">
                        Podrobnosti o konkrétní Akci (termín, místo, cena, obsah) jsou vždy uvedeny na webových stránkách Poskytovatele nebo v pozvánce k Akci.
                    </Paragraph>
                </Container>

                <Container className="mb-6" bgColor="transparent">
                    <Heading variant="h2">3. Přihlášení na Akci a uzavření smlouvy</Heading>
                    <ol className="mt-2 ml-6 list-decimal space-y-2">
                        <li>Přihlášení na Akci probíhá prostřednictvím webového formuláře.</li>
                        <li>Odesláním přihlášky Účastník potvrzuje, že se seznámil s těmito Podmínkami.</li>
                        <li>Smluvní vztah vzniká potvrzením přihlášky ze strany Poskytovatele (e-mailem).</li>
                    </ol>
                </Container>

                <Container className="mb-6" bgColor="transparent">
                    <Heading variant="h2">4. Cena a platební podmínky</Heading>
                    <ol className="mt-2 ml-6 list-decimal space-y-2">
                        <li>Cena Akce je uvedena u konkrétní Akce. Poskytovatel není plátcem DPH, cena je tedy uvedena bez DPH.</li>
                        <li>Poskytovatel vystaví Účastníkovi fakturu před realizací Akce. Faktura bude zaslána e-mailem na adresu uvedenou v přihlášce.</li>
                        <li>Splatnost faktury je <strong>7 až 14 dní</strong> od data vystavení, není-li uvedeno jinak.</li>
                        <li>Platba může být provedena bankovním převodem na účet Poskytovatele uvedený na faktuře.</li>
                        <li>Účast na Akci je možná po uhrazení ceny, pokud není dohodnuto jinak.</li>
                        <li>Po obdržení platby bude vystaven daňový doklad pouze v případě, že je to nutné nebo požadované Účastníkem.</li>
                        <li>V případě neuhrazení ceny ve stanovené lhůtě si Poskytovatel vyhrazuje právo zrušit přihlášku Účastníka.</li>
                    </ol>
                </Container>

                <Container className="mb-6" bgColor="transparent">
                    <Heading variant="h2">5. Zrušení účasti a storno podmínky</Heading>
                    <ol className="mt-2 ml-6 list-decimal space-y-2">
                        <li>Účastník může svou účast zrušit písemně (e-mailem) na kontaktní adresu Poskytovatele.</li>
                        <li>
                            Storno podmínky:
                            <ul className="mt-2 ml-6 list-disc space-y-1">
                                <li>zrušení více než <strong>14 dní</strong> před konáním Akce – bez storno poplatku, vrácení 100 % uhrazené ceny</li>
                                <li>zrušení <strong>7–14 dní</strong> před konáním Akce – storno poplatek <strong>50 % ceny</strong></li>
                                <li>zrušení méně než <strong>7 dní</strong> před konáním Akce – storno poplatek <strong>100 % ceny</strong></li>
                            </ul>
                        </li>
                        <li>Účastník má právo zajistit si náhradníka za sebe. O této změně musí Poskytovatele informovat nejpozději 3 dny před konáním Akce.</li>
                        <li>
                            Poskytovatel si vyhrazuje právo Akci zrušit nebo změnit její termín z vážných důvodů (např. nemoc lektora, nedostatečný počet účastníků, vyšší moc). V takovém případě bude Účastníkovi vrácena uhrazená cena v plné výši nebo nabídnut náhradní termín. Poskytovatel není povinen hradit žádné další náklady spojené se zrušením Akce (např. cestovní náklady, ubytování).
                        </li>
                    </ol>
                </Container>

                <Container className="mb-6" bgColor="transparent">
                    <Heading variant="h2">6. Práva a povinnosti účastníka</Heading>
                    <Paragraph className="mt-2 mb-3">
                        <strong>Povinnosti účastníka:</strong>
                    </Paragraph>
                    <ul className="mt-2 ml-6 list-disc space-y-1">
                        <li>uvádět pravdivé a úplné údaje při přihlášení</li>
                        <li>dodržovat organizační a bezpečnostní pokyny Poskytovatele</li>
                        <li>chovat se tak, aby nenarušoval průběh Akce a ostatní účastníky</li>
                        <li>dodržovat časový harmonogram Akce</li>
                        <li>nenarušovat autorská práva Poskytovatele nebo lektorů</li>
                    </ul>
                    <Paragraph className="mt-4 mb-3">
                        <strong>Práva účastníka:</strong>
                    </Paragraph>
                    <ul className="mt-2 ml-6 list-disc space-y-1">
                        <li>obdržet vzdělávací službu v rozsahu a kvalitě uvedené v popisu Akce</li>
                        <li>obdržet materiály související s Akcí, pokud jsou součástí služby</li>
                        <li>obdržet osvědčení o účasti, pokud je součástí Akce</li>
                    </ul>
                    <Paragraph className="mt-4">
                        Poskytovatel si vyhrazuje právo vyloučit Účastníka, který hrubě porušuje pravidla Akce nebo se chová nevhodně vůči ostatním účastníkům nebo lektorům, bez nároku na vrácení ceny.
                    </Paragraph>
                </Container>

                <Container className="mb-6" bgColor="transparent">
                    <Heading variant="h2">7. Autorská práva</Heading>
                    <Paragraph>
                        Veškeré materiály poskytnuté v rámci Akce jsou chráněny autorským právem.
                    </Paragraph>
                    <Paragraph className="mt-4">
                        Účastník není oprávněn tyto materiály bez předchozího písemného souhlasu Poskytovatele dále šířit, kopírovat nebo využívat ke komerčním účelům.
                    </Paragraph>
                </Container>

                <Container className="mb-6" bgColor="transparent">
                    <Heading variant="h2">8. Odpovědnost</Heading>
                    <ul className="mt-2 ml-6 list-disc space-y-1">
                        <li>Poskytovatel neodpovídá za škody způsobené nesprávným použitím informací získaných na Akci.</li>
                        <li>Poskytovatel neodpovídá za osobní věci Účastníků v průběhu Akce.</li>
                        <li>Poskytovatel neodpovídá za škody vzniklé v důsledku vyšší moci nebo okolností, které nemohl ovlivnit.</li>
                        <li>Odpovědnost Poskytovatele za škody způsobené porušením smlouvy je omezena na přímé škody a maximálně do výše ceny zaplacené za Akci.</li>
                        <li>Poskytovatel neodpovídá za nepřímé škody, ušlý zisk nebo jiné následné škody.</li>
                    </ul>
                </Container>

                <Container className="mb-6" bgColor="transparent">
                    <Heading variant="h2">9. Ochrana osobních údajů</Heading>
                    <Paragraph>
                        Ochrana osobních údajů je řešena samostatným dokumentem <strong>Zásady zpracování osobních údajů</strong>, dostupným na webových stránkách Poskytovatele.
                    </Paragraph>
                    <Paragraph className="mt-4">
                        Účastník souhlasí se zpracováním svých osobních údajů za účelem plnění smlouvy a komunikace související s Akcí v rozsahu nezbytném pro plnění smlouvy.
                    </Paragraph>
                </Container>

                <Container className="mb-6" bgColor="transparent">
                    <Heading variant="h2">10. Reklamace</Heading>
                    <ol className="mt-2 ml-6 list-decimal space-y-2">
                        <li>Účastník má právo uplatnit reklamaci týkající se poskytnuté služby.</li>
                        <li>Reklamace musí být podána písemně (e-mailem) na kontaktní adresu Poskytovatele do 14 dní od ukončení Akce.</li>
                        <li>Reklamace musí obsahovat popis předmětu reklamace a požadované řešení.</li>
                        <li>Poskytovatel se zavazuje reklamaci vyřídit do 30 dní od jejího obdržení.</li>
                        <li>V případě oprávněné reklamace může Poskytovatel nabídnout náhradní řešení nebo částečnou úhradu ceny.</li>
                    </ol>
                </Container>

                <Container className="mb-6" bgColor="transparent">
                    <Heading variant="h2">11. Změna podmínek</Heading>
                    <Paragraph>
                        Poskytovatel si vyhrazuje právo tyto Podmínky jednostranně změnit. Změna se vztahuje pouze na smlouvy uzavřené po nabytí účinnosti změny. Účastník bude o změně Podmínek informován zveřejněním nového znění na webových stránkách Poskytovatele.
                    </Paragraph>
                </Container>

                <Container className="mb-6" bgColor="transparent">
                    <Heading variant="h2">12. Závěrečná ustanovení</Heading>
                    <ol className="mt-2 ml-6 list-decimal space-y-2">
                        <li>Tyto Podmínky jsou platné od <strong>1. ledna 2025</strong>.</li>
                        <li>Aktuální znění Podmínek je vždy dostupné na webových stránkách Poskytovatele.</li>
                        <li>Právní vztahy se řídí právním řádem České republiky.</li>
                        <li>V případě sporu se strany zavazují pokusit se o mimosoudní řešení. Pokud se nedohodnou, příslušným soudem je soud podle sídla Poskytovatele.</li>
                        <li>Pokud by některé ustanovení těchto Podmínek bylo neplatné nebo neúčinné, neovlivní to platnost ostatních ustanovení.</li>
                    </ol>
                </Container>

                <Container className="mt-8 pt-4 border-t border-gray-300" bgColor="transparent">
                    <Paragraph variant="small">
                        Poslední aktualizace: <strong>1. ledna 2025</strong>
                    </Paragraph>
                </Container>
            </Container>
        </Container>
        </>
    )
}

